import { ChakraThemeKeySchema } from '~/schemas/chakraTheme'
import { chakraThemeMap } from '~/themes/chakra'

export const getChakraThemeFromKey = (key: string) => {
  const themeKeyParse = ChakraThemeKeySchema.safeParse(key)

  if (!themeKeyParse.success) {
    return chakraThemeMap.avios
  }

  return chakraThemeMap[themeKeyParse.data]
}
